import type { ReactNode } from 'react';
import styled, { css, useTheme } from 'styled-components';
import { TypographyVariant } from '../../utils/theme';
import type { RIconComponent } from '../remix-icon';
import RIcon from '../remix-icon';
import Typography from '../typography/typography';

interface PageHeaderBannerProps {
  bannerIcon: RIconComponent;
  bannerText: ReactNode;
}

const PageHeaderBanner = ({
  bannerIcon,
  bannerText,
}: PageHeaderBannerProps) => {
  const theme = useTheme();

  return (
    <BannerWrapper>
      <RIcon icon={bannerIcon} color={theme.palette.neutral['00']} size="md" />
      <BannerTypography
        variant={TypographyVariant.bodyMd1}
        color={theme.palette.neutral['00']}
      >
        {bannerText}
      </BannerTypography>
    </BannerWrapper>
  );
};

export default PageHeaderBanner;

const BannerWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    padding: ${theme.spacing(1.5, 5)};
    gap: ${theme.spacing(1.5)};
    background-color: ${theme.palette.neutral[90]};
  `}
`;

const BannerTypography = styled(Typography)`
  line-height: 1.5rem;
`;
